import IAction from '@signageos/actions/dist/IAction';

export const ActiveAppletRestore = 'Front.Applet.ActiveAppletRestore';
export interface ActiveAppletRestore extends IAction<typeof ActiveAppletRestore> {}
